import React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { FaIcon, faCircleInfo } from '@/lib/fa'
import { GROUP_END_TITLE_KEYS } from './timesheetGroups'

const RowInfoItem = ({
  width,
  height,
  headerHeight,
  rowInfo,
  selectedRows = [],
  hoveredRow,
  onRowClick,
  onRowMouseEnter,
  onRowMouseLeave,
  onExplainRow,
}) => {
  const { tSafe } = useLocalize()
  const selectedSet = new Set<number>(selectedRows)
  return (
    <div className="tw-flex tw-flex-col" style={{ paddingTop: headerHeight }}>
      {rowInfo &&
        rowInfo.map((info, index) => {
          const translatedTitle = info.titleKey
            ? tSafe(`timesheet.row-titles.${info.titleKey}`, info.title)
            : info.title
          const isSel = selectedSet.has(index)
          const isHov = hoveredRow === index
          const prevTitleKey =
            index > 0 ? rowInfo[index - 1]?.titleKey : undefined
          const isAfterBoundary =
            !!prevTitleKey && GROUP_END_TITLE_KEYS.has(prevTitleKey)
          const isBoundary =
            !!info.titleKey && GROUP_END_TITLE_KEYS.has(info.titleKey)
          return (
            <React.Fragment key={index}>
              <div
                className={`tw-relative tw-flex tw-cursor-pointer tw-select-none tw-items-center tw-border tw-border-solid tw-bg-base-100 ${index > 0 && !isAfterBoundary ? '-tw-mt-px' : ''}`}
                style={{
                  height: info.isWorkTimeEvent ? height + 6 : height + 2,
                  minWidth: width,
                  borderBottomWidth: 1,
                }}
                onClick={(e) => onRowClick?.(index, e)}
                onMouseEnter={() => onRowMouseEnter?.(index)}
                onMouseLeave={() => onRowMouseLeave?.()}
              >
                {isSel && (
                  <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-[#0034FF]/15" />
                )}
                {!isSel && isHov && (
                  <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-[#0034FF]/10" />
                )}
                <span
                  className={`tw-relative tw-flex-1 tw-truncate tw-text-[10px] tw-text-content-base ${info?.isChildEvent ? 'tw-pl-5' : 'tw-pl-1.5'} ${info?.isWorkTimeEvent ? 'tw-font-medium' : 'tw-font-normal'}`}
                >
                  {translatedTitle}
                </span>
                {onExplainRow && info?.titleKey && (
                  <button
                    type="button"
                    className="tw-relative tw-mr-1 tw-flex tw-h-4 tw-w-4 tw-flex-none tw-items-center tw-justify-center tw-rounded tw-text-neutral hover:tw-bg-content-primary hover:tw-text-primary"
                    aria-label={tSafe(
                      'explain.row.icon-aria',
                      'Explain this row',
                    )}
                    onClick={(e) => {
                      e.stopPropagation()
                      onExplainRow(info.titleKey)
                    }}
                  >
                    <FaIcon icon={faCircleInfo} className="tw-h-3 tw-w-3" />
                  </button>
                )}
              </div>
              {isBoundary && (
                <div
                  style={{
                    height: 1,
                    backgroundColor: '#0034FF',
                    opacity: 0.5,
                    minWidth: width,
                  }}
                />
              )}
            </React.Fragment>
          )
        })}
    </div>
  )
}

export default RowInfoItem
